<template>
    <div class="instituicao">

        <c-panel v-if="editInstituicao && !dados.id">
            <div class="loading-form" style="min-height: 300px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <el-form @submit.native.prevent="onSubmitInstituicao" v-if="!editInstituicao || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editInstituicao || dados.id">

                <c-panel>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item class="u-text-center" label="Logo da Instituição" prop="logo" key="logo">
                                <input-image v-model="logoFile" :maxBytes="2097152" @erro="onLogoErro" @delete="onLogoDelete"></input-image>
                                <small class="u-text-muted" style="display:block; text-align:center;">PNG ou JPEG, até 2MB.</small>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="!logoFile && logoUrl" :xs="24" :sm="4" :md="4">
                            <img :src="logoUrl" class="img-avatar" style="max-width:180px; margin: 8px auto; display:block;">
                        </el-col>
                        <el-col :xs="24" :sm="!logoFile && logoUrl ? 16 : 20" :md="!logoFile && logoUrl ? 16 : 20">
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="18" :md="18">
                                    <el-form-item label="Nome*" prop="nome" :rules="[$requiredBlur]" key="nome">
                                        <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Apelido*" prop="apelido" :rules="[$requiredBlur]" key="apelido">
                                        <el-input v-model="dados.apelido" maxlength="191" v-on:blur="formatData('apelido')"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="INEP" prop="inep" key="inep">
                                        <el-input v-model="dados.inep" v-mask="'##########'" maxlength="191"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Situação*" prop="situacao_funcionamento" :rules="[$requiredChange]" key="situacao_funcionamento">
                                        <el-select :disabled="$store.state.user.tipo != 6" v-model="dados.situacao_funcionamento">
                                            <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_FUNCIONAMENTO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="CEP*" prop="cep" :rules="[$requiredBlur]" key="cep">
                                        <el-input v-on:blur="buscarViaCep()" v-model="dados.cep" v-mask="'#####-###'" maxlength="191"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="12" :md="12">
                                    <el-form-item label="Logradouro*" prop="logradouro" :rules="[$requiredBlur]" key="logradouro">
                                        <el-input v-model="dados.logradouro" maxlength="191" v-on:blur="formatData('logradouro')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="4" :md="4">
                                    <el-form-item label="N°*" prop="numero" :rules="[$requiredBlur]" key="numero">
                                        <el-input v-model="dados.numero" maxlength="191"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    
                    
                    
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Bairro*" prop="bairro" :rules="[$requiredBlur]" key="bairro">
                                <el-input v-model="dados.bairro" maxlength="191" v-on:blur="formatData('bairro')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Localização*" prop="localizacao_zona" :rules="[$requiredBlur]" key="localizacao_zona">
                                <el-select v-model="dados.localizacao_zona">
                                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_ZONA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Cidade*" prop="cidade" :rules="[$requiredBlur]" key="cidade">
                                <el-input :readonly="true" v-model="dados.cidade" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Estado*" prop="estado" :rules="[$requiredBlur]" key="estado">
                                <el-input :readonly="true" v-model="dados.estado" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Distrito*" prop="distrito_id" :rules="[$requiredBlur]" key="distrito_id">
                                <el-select v-model="dados.distrito_id">
                                    <el-option v-for="(item, i) in selectDistritos" :key="i" :label="item.nome_distrito" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Complemento" prop="complemento" key="complemento">
                                <el-input v-model="dados.complemento" maxlength="191" v-on:blur="formatData('complemento')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="9" :md="9">
                            <el-form-item label="Latitude" prop="latitude" key="latitude">
                                <el-input v-model="dados.latitude" maxlength="20" placeholder="-22.475600"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="9" :md="9">
                            <el-form-item label="Longitude" prop="longitude" key="longitude">
                                <el-input v-model="dados.longitude" maxlength="20" placeholder="-46.631300"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item class="u-text-right">
                                <el-button class="u-mt-20" type="primary" plain :loading="localizando" @click="localizarPeloEndereco()">Localizar pelo endereço</el-button>
                                <el-button plain @click="dialogMapa = true">Ajustar no mapa</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="reset-text-transform">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="E-mail" :rules="[$emailBlur]" prop="email" key="email">
                                <el-input v-model="dados.email" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Telefone" prop="telefone" key="telefone">
                                <el-input v-model="dados.telefone" v-mask="'(##) ########'" v-on:blur="formatData('telefone', 13)" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Celular" prop="celular" key="celular">
                                <el-input v-model="dados.celular" v-mask="'(##) #########'" v-on:blur="formatData('celular', 14)" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Dependência Administrativa*" :rules="[$requiredChange]" prop="dependencia_administrativa" key="dependencia_administrativa">
                                <el-select disabled v-model="dados.dependencia_administrativa">
                                    <el-option v-for="(item, i) in $CONSTANTS.DEPENDENCIA_ADMINISTRATIVA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Localização Diferenciada*" :rules="[$requiredChange]" prop="localizacao_diferenciada" key="localizacao_diferenciada">
                                <el-select v-model="dados.localizacao_diferenciada">
                                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_DIFERENCIADA_ESCOLA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Instituição regulamentada ou autorizada no conselho ou órgão municipal, estadual ou federal de educação?" :rules="[$requiredChange]" prop="regulamentacao_autorizacao" key="regulamentacao_autorizacao">
                                <el-select v-model="dados.regulamentacao_autorizacao">
                                    <el-option v-for="(item, i) in $CONSTANTS.REGULAMENTACAO_AUTORIZACAO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Órgão Regional Vinculada a Instituição" prop="orgao_regional" key="orgao_regional">
                                <el-input v-model="dados.orgao_regional" maxlength="191" placeholder="Informe o órgão regional vinculado à instituição"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <el-tabs type="border-card">

                    <el-tab-pane v-if="!editInstituicao" label="PERÍODO LETIVO">
                        <div>
                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item label="Nome" prop="periodo.nome" :rules="[$requiredBlur]" key="nome">
                                        <el-input class="readonly" v-model="dados.periodo.nome" maxlength="191"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Data de Início do Período" prop="periodo.data_inicial" :rules="[$requiredBlur, $dataBlur]" key="data_inicial">
                                        <el-input v-model="dados.periodo.data_inicial" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatDataPeriodo('data_inicial', 10)"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Data de Término do Período" prop="periodo.data_final" :rules="[$requiredBlur, $dataBlur]" key="data_final">
                                        <el-input v-model="dados.periodo.data_final" maxlength="191" v-mask="'##/##/####'" v-on:blur="formatDataPeriodo('data_final', 10)"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="8" :md="8">
                                    <el-form-item label="Quantidade de Dias Letivos" prop="periodo.qtd_dias_letivos" :rules="[$requiredBlur]" key="qtd_dias_letivos">
                                        <el-input v-model="dados.periodo.qtd_dias_letivos" maxlength="191" v-mask="'###'"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="INFRAESTRUTURA">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Local de Funcionamento" prop="locais_funcionamento" key="locais_funcionamento">
                                    <el-select v-model="dados.infras_instituicoes.locais_funcionamento" multiple>
                                        <el-option v-for="(item, i) in selects.localFuncionamento" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Forma de Ocupação do Prédio" prop="forma_ocupacao" key="forma_ocupacao">
                                    <el-select v-model="dados.infras_instituicoes.forma_ocupacao">
                                        <el-option v-for="(item, i) in $CONSTANTS.FORMA_OCUPACAO_PREDIO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Prédio Compartilhado com outra Instituição" prop="predio_compartilhado" key="predio_compartilhado">
                                    <el-select v-model="dados.infras_instituicoes.predio_compartilhado">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" v-if="dados.infras_instituicoes.predio_compartilhado">
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="INEP da Escola 1" prop="cod_instituicao_compartilha_1" key="cod_instituicao_compartilha_1">
                                    <el-input v-model="dados.infras_instituicoes.cod_instituicao_compartilha_1" maxlength="191" v-mask="'########'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="INEP da Escola 2" prop="cod_instituicao_compartilha_2" key="cod_instituicao_compartilha_2">
                                    <el-input v-model="dados.infras_instituicoes.cod_instituicao_compartilha_2" maxlength="191" v-mask="'########'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="INEP da Escola 3" prop="cod_instituicao_compartilha_3" key="cod_instituicao_compartilha_3">
                                    <el-input v-model="dados.infras_instituicoes.cod_instituicao_compartilha_3" maxlength="191" v-mask="'########'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="INEP da Escola 4" prop="cod_instituicao_compartilha_4" key="cod_instituicao_compartilha_4">
                                    <el-input v-model="dados.infras_instituicoes.cod_instituicao_compartilha_4" maxlength="191" v-mask="'########'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="INEP da Escola 5" prop="cod_instituicao_compartilha_5" key="cod_instituicao_compartilha_5">
                                    <el-input v-model="dados.infras_instituicoes.cod_instituicao_compartilha_5" maxlength="191" v-mask="'########'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="INEP da Escola 6" prop="cod_instituicao_compartilha_6" key="cod_instituicao_compartilha_6">
                                    <el-input v-model="dados.infras_instituicoes.cod_instituicao_compartilha_6" maxlength="191" v-mask="'########'"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Fornece Água Potável Para Consumo Humano?" prop="fornece_agua_potavel" key="fornece_agua_potavel">
                                    <el-select v-model="dados.infras_instituicoes.fornece_agua_potavel">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Internet Banda Larga" prop="internet_banda_larga" key="internet_banda_larga">
                                    <el-select v-model="dados.infras_instituicoes.internet_banda_larga">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Recursos de Acessibilidade" prop="recursos_acessibilidade" key="recursos_acessibilidade">
                                    <el-select v-model="dados.infras_instituicoes.recursos_acessibilidade" multiple>
                                        <el-option v-for="(item, i) in selects.recursoAcessibilidade" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="5" :md="5">
                                <el-form-item label="Qtd. Salas Internas" prop="qtd_salas_internas" key="qtd_salas_internas">
                                    <el-input v-model="dados.infras_instituicoes.qtd_salas_internas" maxlength="191" v-mask="'###'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="5" :md="5">
                                <el-form-item label="Qtd. Salas Externas" prop="qtd_salas_externas" key="qtd_salas_externas">
                                    <el-input v-model="dados.infras_instituicoes.qtd_salas_externas" maxlength="191" v-mask="'###'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="5" :md="5">
                                <el-form-item label="Qtd. Salas Climatizadas" prop="qtd_salas_climatizadas" key="qtd_salas_climatizadas">
                                    <el-input v-model="dados.infras_instituicoes.qtd_salas_climatizadas" maxlength="191" v-mask="'###'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="5" :md="5">
                                <el-form-item label="Qtd. Salas c/ Acessibilidade" prop="qtd_salas_com_acessibilidade" key="qtd_salas_com_acessibilidade">
                                    <el-input v-model="dados.infras_instituicoes.qtd_salas_com_acessibilidade" maxlength="191" v-mask="'###'"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="4" :md="4">
                                <el-form-item label="Qtd. Salas c/ Cantinho da Leitura" prop="qtd_salas_cantinho_leitura" key="qtd_salas_cantinho_leitura">
                                    <el-input v-model="dados.infras_instituicoes.qtd_salas_cantinho_leitura" maxlength="5" v-mask="'###'"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Acesso a Internet" prop="opcoes_uso_internet" key="opcoes_uso_internet">
                                    <el-select @change="changeAcessoInternet()" v-model="dados.infras_instituicoes.opcoes_uso_internet" multiple>
                                        <el-option v-for="(item, i) in selects.opcaoUsoInternet" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Equipamentos que os Alunos usam para o acesso a Internet" prop="equipamentos_alunos_uso_internet" key="equipamentos_alunos_uso_internet">
                                    <el-select v-model="dados.infras_instituicoes.equipamentos_alunos_uso_internet" multiple>
                                        <el-option v-for="(item, i) in selects.equipamentoAlunoUsoInternet" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Rede Local de Interligação de Computadores" prop="equipamentos_rede_local_computadores" key="equipamentos_rede_local_computadores">
                                    <el-select @change="changeRedeLocalInterlComp()" v-model="dados.infras_instituicoes.equipamentos_rede_local_computadores" multiple>
                                        <el-option v-for="(item, i) in selects.equipamentoRedeLocalComputador" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Alimentação Escolar p/ Alunos" prop="alimentacao_escolar" key="alimentacao_escolar">
                                    <el-select v-model="dados.infras_instituicoes.alimentacao_escolar">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Educação Escolar Indígena" prop="educacao_escolar_indigena" key="educacao_escolar_indigena">
                                    <el-select v-model="dados.infras_instituicoes.educacao_escolar_indigena">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Instrumentos Pedagógicos" prop="instrumentos_pedagogicos" key="instrumentos_pedagogicos">
                                    <el-select v-model="dados.infras_instituicoes.instrumentos_pedagogicos" multiple>
                                        <el-option v-for="(item, i) in selects.instrumentoPedagogico" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="8" :md="8">
                                <el-form-item label="Possui Site ou Blog?" prop="possui_site_blog" key="possui_site_blog">
                                    <el-select v-model="dados.infras_instituicoes.possui_site_blog">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="8" :md="8">
                                <el-form-item label="Compartilha Espaço com a Comunidade?" prop="instituicao_compartilha_espaco" key="instituicao_compartilha_espaco">
                                    <el-select v-model="dados.infras_instituicoes.instituicao_compartilha_espaco">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="8" :md="8">
                                <el-form-item label="Usa Espaço e Equipamentos Entorno da Instituição?" prop="uso_espaco_equipamento_entorno" key="uso_espaco_equipamento_entorno">
                                    <el-select v-model="dados.infras_instituicoes.uso_espaco_equipamento_entorno">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Órgão Colegiado em Funcionamento" prop="orgaos_colegiados" key="orgaos_colegiados">
                                    <el-select @change="changeOrgaoColegiado()" v-model="dados.infras_instituicoes.orgaos_colegiados" multiple>
                                        <el-option v-for="(item, i) in selects.orgaoColegiado" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="A escola desenvolve ações na área de educação ambiental?" prop="acao_ambiental" key="acao_ambiental">
                                    <el-select v-model="dados.infras_instituicoes.acao_ambiental">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" v-if="dados.infras_instituicoes.acao_ambiental">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Informe de qual(quais) forma(s) a educação ambiental é desenvolvida na escola" prop="acoes_ambientais" key="acoes_ambientais">
                                    <el-select @change="changeAcaoAmbiental()" v-model="dados.infras_instituicoes.acoes_ambientais" multiple>
                                        <el-option v-for="(item, i) in selects.acoesAmbientais" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>    
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Projeto político pedagógico ou a proposta pedagógica da escola (conforme art. 12 da LDB) atualizado nos últimos 12 meses até a data de referência">
                                    <el-select v-model="dados.infras_instituicoes.projeto_politico_pedagogico">
                                        <el-option :key="0" label="NÃO" :value="0"></el-option>
                                        <el-option :key="1" label="SIM" :value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-tab-pane>

                    <el-tab-pane label="SERVIÇOS">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Abastecimento de Água" prop="abastecimento_agua" key="abastecimento_agua">
                                    <el-select @change="changeAbastecimentoAgua()" v-model="dados.infras_instituicoes.abastecimento_agua" multiple>
                                        <el-option v-for="(item, i) in selects.abastecimentoAgua" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Abastecimento de Energia" prop="abastecimento_energia" key="abastecimento_energia">
                                    <el-select @change="changeAbastecimentoEnergia()" v-model="dados.infras_instituicoes.abastecimento_energia" multiple>
                                        <el-option v-for="(item, i) in selects.abastecimentoEnergia" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Esgotamento Sanitário" prop="esgoto_sanitario" key="esgoto_sanitario">
                                    <el-select @change="changeAbastecimentoEsgotamento()" v-model="dados.infras_instituicoes.esgoto_sanitario" multiple>
                                        <el-option v-for="(item, i) in selects.esgotoSanitario" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Destinação do Lixo" prop="destinacao_lixo" key="destinacao_lixo">
                                    <el-select v-model="dados.infras_instituicoes.destinacao_lixo" multiple>
                                        <el-option v-for="(item, i) in selects.destinacaoLixo" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <el-form-item label="Tratamento do lixo/resíduos que a escola realiza" prop="tratamento_lixo" key="tratamento_lixo">
                                    <el-select v-model="dados.infras_instituicoes.tratamento_lixo" multiple>
                                        <el-option v-for="(item, i) in selects.tratamentoLixo" :key="i" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-tab-pane>

                    <el-tab-pane label="DEPENDÊNCIAS">

                        <el-row class="u-mt-10 u-mb-20">
                            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                <el-button type="primary" @click="showDialogDependencia">NOVA DEPENDÊNCIA</el-button>
                            </el-col>
                        </el-row>
                        <div class="container-table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th style="width: 150px;" class="u-text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in dados.infras_instituicoes.dependencias_instituicao" :key="i">
                                        <td>{{ selects.dependenciaInstituicao[item].nome }}</td>
                                        <td class="u-text-center acao">
                                            <el-button @click="deleteDependencia(item)" title="Excluir" type="danger" icon="el-icon-delete" size="mini"></el-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="dados.infras_instituicoes.dependencias_instituicao.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </el-tab-pane>

                    <el-tab-pane label="EQUIPAMENTOS">

                        <el-row class="u-mt-10 u-mb-20">
                            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                <el-button type="primary" @click="showDialogEquipamentos">NOVO EQUIPAMENTO</el-button>
                            </el-col>
                        </el-row>
                        <div class="container-table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th class="u-text-center">Quantidade</th>
                                        <th style="width: 150px;" class="u-text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in dados.infras_instituicoes.equipamentos_quantidades" :key="i">
                                        <td>{{ selects.equipamentoExistenteEscola[item.equipamento_existente_escola_id].nome }}</td>
                                        <td class="u-text-center">{{ item.qtd }}</td>
                                        <td class="u-text-center acao">
                                            <el-button @click="deleteEquipamento(item)" title="Excluir" type="danger" icon="el-icon-delete" size="mini"></el-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="dados.infras_instituicoes.equipamentos_quantidades.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </el-tab-pane>

                    <el-tab-pane label="PROFISSIONAIS ESCOLARES">

                        <el-row class="u-mt-10 u-mb-20">
                            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                                <el-button type="primary" @click="showDialogProfissional">NOVO PROFISSIONAL</el-button>
                            </el-col>
                        </el-row>
                        <div class="container-table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th class="u-text-center">Quantidade</th>
                                        <th style="width: 150px;" class="u-text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in dados.infras_instituicoes.profissionais_atuam_instituicoes_qtd" :key="i">
                                        <td>{{ selects.profissionalAtuaInstituicao[item.profissional_atua_instituicao_id].nome }}</td>
                                        <td class="u-text-center">{{ item.qtd }}</td>
                                        <td class="u-text-center acao">
                                            <el-button @click="deleteProfissional(item)" title="Excluir" type="danger" icon="el-icon-delete" size="mini"></el-button>                                            
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr v-if="dados.infras_instituicoes.profissionais_atuam_instituicoes_qtd.length == 0" style="border-top: 1px solid #ddd;">
                                        <td colspan="100%" class="u-text-center">
                                            <span>- nenhum registro -</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </el-tab-pane>

                </el-tabs>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <div class="u-text-right u-mt-15">
                            <el-button id="btn-instituicao" type="primary" native-type="submit">SALVAR</el-button>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </el-form>

        <el-dialog :close-on-click-modal="false" title="AJUSTAR LOCALIZAÇÃO NO MAPA" :visible.sync="dialogMapa" width="800px">
            <mapa-endereco v-if="dialogMapa" :endereco="[dados.logradouro, dados.numero, dados.bairro, dados.cidade].filter(Boolean).join(', ')"
                :sugestao="coordenadaAtual" :posicionado="!!coordenadaAtual" v-on:confirmar="confirmarMapa" v-on:cancelar="dialogMapa = false"></mapa-endereco>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="ADICIONAR DEPENDÊNCIA" :visible.sync="dialogDependencias" v-on:close="resetFormDependencias">
            <div v-if="dialogDependencias" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormDependencias" :model="formDependencias" ref="formDependencias" label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Dependências" prop="dependencia_id" key="dependencia_id">
                                <el-select v-model="formDependencias.dependencia_id" filterable placeholder="Pesquisar dependência">
                                    <el-option v-for="item in selects.dependenciaInstituicao" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="ADICIONAR EQUIPAMENTO" :visible.sync="dialogEquipamentos" v-on:close="resetFormEquipamentos">
            <div v-if="dialogEquipamentos" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormEquipamentos" :model="formEquipamentos" ref="formEquipamentos" label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="20" :md="20">
                            <el-form-item label="Equipamento" prop="equipamento_existente_escola_id" key="equipamento_existente_escola_id">
                                <el-select v-model="formEquipamentos.equipamento_existente_escola_id" filterable placeholder="Pesquisar equipamento">
                                    <el-option v-for="item in selects.equipamentoExistenteEscola" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Quantidade" prop="qtd" :rules="[$requiredBlur]" key="qtd">
                                <el-input v-model="formEquipamentos.qtd" maxlength="191" v-mask="'####'"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="ADICIONAR PROFISSIONAL ESCOLAR" width="80%" :visible.sync="dialogProfissional" v-on:close="resetFormProfissional">
            <div v-if="dialogProfissional" style="margin-top: 20px;">

                <el-form @submit.native.prevent="onSubmitFormProfissional" :model="formProfissional" ref="formProfissional" label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="20" :md="20">
                            <el-form-item label="Tipo do Profissional" prop="profissional_atua_instituicao_id" key="profissional_atua_instituicao_id">
                                <el-select v-model="formProfissional.profissional_atua_instituicao_id" filterable placeholder="Pesquisar profissional">
                                    <el-option v-for="item in selects.profissionalAtuaInstituicao" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Quantidade" prop="qtd" :rules="[$requiredBlur]" key="qtd">
                                <el-input v-model="formProfissional.qtd" maxlength="191" v-mask="'####'"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24">
                            <el-form-item class="u-text-right u-mt-15">
                                <el-button type="primary" native-type="submit">SALVAR</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>
        </el-dialog>

    </div>
</template>
<script>

import Vue from 'vue'
import InputImage from '@/shared/input-image/input-image.vue'
import mapaEndereco from '@/components/aluno/mapa-endereco'

export default {
    props: ['paramId'],
    data: () => ({
        editInstituicao: false,
        logoFile: '',
        logoUrl: '',
        selects: {},
        dialogDependencias: false,
        dialogMapa: false,
        localizando: false,
        dialogEquipamentos: false,
        dialogProfissional: false,
        dados: {
            id: '',
            nome: '',
            inep: '',
            situacao_funcionamento: '',
            logradouro: '',
            numero: '',
            bairro: '',
            cidade: '',
            estado: '',
            latitude: '',
            longitude: '',
            cep: '',
            complemento: '',
            distrito_id: '',
            telefone: '',
            celular: '',
            localizacao_diferenciada: '',
            dependencia_administrativa: 3,
            email: '',
            localizacao_zona: '',
            pre_matricula: '',
            regulamentacao_autorizacao: '',
            orgao_regional: '',
            periodo: {
                nome: '',
                situacao: '',
                data_inicial: '',
                data_final: '',
                qtd_dias_letivos: '',
                periodo_letivo_id: ''
            },
            infra_instituicao_id: '',
            infras_instituicoes: {
                forma_ocupacao: '',
                predio_compartilhado: '',
                cod_instituicao_compartilha_1: '',
                cod_instituicao_compartilha_2: '',
                cod_instituicao_compartilha_3: '',
                cod_instituicao_compartilha_4: '',
                cod_instituicao_compartilha_5: '',
                cod_instituicao_compartilha_6: '',
                fornece_agua_potavel: '',
                qtd_salas_internas: '',
                qtd_salas_externas: '',
                qtd_salas_climatizadas: '',
                qtd_salas_com_acessibilidade: '',
                internet_banda_larga: '',
                alimentacao_escolar: '',
                educacao_escolar_indigena: '',
                possui_site_blog: '',
                compartilha: '',
                instituicao_compartilha_espaco: '',
                uso_espaco_equipamento_entorno: '',
                projeto_politico_pedagogico: '',
                instituicao_id: '',
                periodo_letivo_id: '',
                locais_funcionamento: [],
                abastecimento_agua: [],
                abastecimento_energia: [],
                esgoto_sanitario: [],
                destinacao_lixo: [],
                tratamento_lixo: [],
                dependencias_instituicao: [],
                equipamentos_quantidades: [],
                recursos_acessibilidade: [],
                opcoes_uso_internet: [],
                equipamentos_alunos_uso_internet: [],
                equipamentos_rede_local_computadores: [],
                instrumentos_pedagogicos: [],
                orgaos_colegiados: [],
                profissionais_atuam_instituicoes_qtd: [],
                acoes_ambientais: [],
                acao_ambiental: '',
                qtd_salas_cantinho_leitura: '',

            }

        },
        formDependencias: {
            dependencia_id: ''
        },
        formEquipamentos: {
            equipamento_existente_escola_id: '',
            qtd: ''
        },
        formProfissional: {
            profissional_atua_instituicao_id: '',
            qtd: ''
        },
        selectDistritos: [],
        buscandoCep: false
    }),
    mounted(){

        this.getDistritos();
        this.initForm();
    },
    methods:{
        changeAcessoInternet(){

            for(let i in this.dados.infras_instituicoes.opcoes_uso_internet){
                if(this.dados.infras_instituicoes.opcoes_uso_internet[i] == 5){
                    this.dados.infras_instituicoes.opcoes_uso_internet = [5];
                    break;
                }
            }
        },

        changeAbastecimentoAgua(){

            for(let i in this.dados.infras_instituicoes.abastecimento_agua){
                if(this.dados.infras_instituicoes.abastecimento_agua[i] == 6){
                    this.dados.infras_instituicoes.abastecimento_agua = [6];
                    break;
                }
            }
        },

        changeAbastecimentoEnergia(){

            for(let i in this.dados.infras_instituicoes.abastecimento_energia){
                if(this.dados.infras_instituicoes.abastecimento_energia[i] == 4){
                    this.dados.infras_instituicoes.abastecimento_energia = [4];
                    break;
                }
            }
        },

        changeAbastecimentoEsgotamento(){

            for(let i in this.dados.infras_instituicoes.esgoto_sanitario){
                if(this.dados.infras_instituicoes.esgoto_sanitario[i] == 4){
                    this.dados.infras_instituicoes.esgoto_sanitario = [4];
                    break;
                }
            }
        },

        changeRedeLocalInterlComp(){

            for(let i in this.dados.infras_instituicoes.equipamentos_rede_local_computadores){
                if(this.dados.infras_instituicoes.equipamentos_rede_local_computadores[i] == 3){
                    this.dados.infras_instituicoes.equipamentos_rede_local_computadores = [3];
                    break;
                }
            }
        },
        changeOrgaoColegiado(){

            for(let i in this.dados.infras_instituicoes.orgaos_colegiados){
                if(this.dados.infras_instituicoes.orgaos_colegiados[i] == 6){
                    this.dados.infras_instituicoes.orgaos_colegiados = [6];
                    break;
                }
            }
        },
        changeAcaoAmbiental(){
            for(let i in this.dados.infras_instituicoes.acoes_ambientais){
                if(this.dados.infras_instituicoes.acoes_ambientais[i] == 6){
                    this.dados.infras_instituicoes.acoes_ambientais = [6];
                    break;
                }
            }
        },
        initForm(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/infra-instituicao/initForm`, this.$store.getters.getHeaderAuth).then(response => {

                this.selects = JSON.parse(JSON.stringify(response.data));

                if(this.editInstituicao){

                    this.getInstituicaoById(this.paramId);
                }

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        showDialogDependencia(){

            this.dialogDependencias = true;
        },
        onSubmitFormDependencias(){

            this.$refs.formDependencias.validate((valid) =>{ if(valid){

                this.dados.infras_instituicoes.dependencias_instituicao.push(this.formDependencias.dependencia_id);
                this.dialogDependencias = false;

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        deleteDependencia(index){

            for(let i in this.dados.infras_instituicoes.dependencias_instituicao){

                if(this.dados.infras_instituicoes.dependencias_instituicao[i] == index){

                    this.dados.infras_instituicoes.dependencias_instituicao.splice(i, 1);
                }
            }
        },
        resetFormDependencias(){

            this.formDependencias = { dependencia_id: '' };
        },
        showDialogEquipamentos(){

            this.dialogEquipamentos = true;
        },
        onSubmitFormEquipamentos(){

            this.$refs.formEquipamentos.validate((valid) =>{ if(valid){

                if(this.formEquipamentos.qtd == 0){
                    window.eventBus.$emit('alert', {msg: 'A quantidade precisa ser maior que zero.', type: 'warning'});
                    return false;
                }

                this.dados.infras_instituicoes.equipamentos_quantidades.push({ equipamento_existente_escola_id: this.formEquipamentos.equipamento_existente_escola_id, qtd: this.formEquipamentos.qtd });
                this.dialogEquipamentos = false;

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        deleteEquipamento(index){

            for(let i in this.dados.infras_instituicoes.equipamentos_quantidades){

                if(this.dados.infras_instituicoes.equipamentos_quantidades[i] == index){

                    this.dados.infras_instituicoes.equipamentos_quantidades.splice(i, 1);
                }
            }
        },
        resetFormEquipamentos(){

            this.formEquipamentos = { equipamento_existente_escola_id: '', qtd: '' };
        },
        showDialogProfissional(){
            this.dialogProfissional = true;
        },
        onSubmitFormProfissional(){

            this.$refs.formProfissional.validate((valid) =>{ if(valid){

                if(this.formProfissional.qtd == 0){
                    window.eventBus.$emit('alert', {msg: 'A quantidade precisa ser maior que zero.', type: 'warning'});
                    return false;
                }

                this.dados.infras_instituicoes.profissionais_atuam_instituicoes_qtd.push({ profissional_atua_instituicao_id: this.formProfissional.profissional_atua_instituicao_id, qtd: this.formProfissional.qtd });
                this.dialogProfissional = false;

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        deleteProfissional(index){

            for(let i in this.dados.infras_instituicoes.profissionais_atuam_instituicoes_qtd){

                if(this.dados.infras_instituicoes.profissionais_atuam_instituicoes_qtd[i] == index){

                    this.dados.infras_instituicoes.profissionais_atuam_instituicoes_qtd.splice(i, 1);
                }
            }
        },
        resetFormProfissional(){

            this.formProfissional = { profissional_atua_instituicao_id: '', qtd: '' };
        },
        getDistritos(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/distrito/getAll`, this.$store.getters.getHeaderAuth).then(response => {

                this.selectDistritos = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getInstituicoes(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAllInstituicoesForInitSistema`, this.$store.getters.getHeaderAuth).then(response => {

                this.$store.commit('setListInstituicoes', response.data);

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPeriodoSistema(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/parametro/get`, this.$store.getters.getHeaderAuth).then(response => {

                this.dados.periodo.nome = response.data.periodo_letivo_base_nome;
                this.dados.periodo.periodo_letivo_id = response.data.periodo_letivo_base_id;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getInstituicaoById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));

                this.logoFile = '';
                this.logoUrl = this.dados.logo_path ? `${this.$store.state.config.baseUrlApi}/storage/` + this.dados.logo_path : '';

                this.dados.dependencia_administrativa = 3;

                if(!response.data.infra_instituicao_id){

                    this.dados.infras_instituicoes = {

                        forma_ocupacao: '',
                        predio_compartilhado: '',
                        cod_instituicao_compartilha_1: '',
                        cod_instituicao_compartilha_2: '',
                        cod_instituicao_compartilha_3: '',
                        cod_instituicao_compartilha_4: '',
                        cod_instituicao_compartilha_5: '',
                        cod_instituicao_compartilha_6: '',
                        fornece_agua_potavel: '',
                        qtd_salas_internas: '',
                        qtd_salas_externas: '',
                        qtd_salas_climatizadas: '',
                        qtd_salas_com_acessibilidade: '',
                        internet_banda_larga: '',
                        alimentacao_escolar: '',
                        educacao_escolar_indigena: '',
                        possui_site_blog: '',
                        compartilha: '',
                        instituicao_compartilha_espaco: '',
                        uso_espaco_equipamento_entorno: '',
                        projeto_politico_pedagogico: '',
                        instituicao_id: '',
                        periodo_letivo_id: '',
                        locais_funcionamento: [],
                        abastecimento_agua: [],
                        abastecimento_energia: [],
                        esgoto_sanitario: [],
                        destinacao_lixo: [],
                        tratamento_lixo: [],
                        dependencias_instituicao: [],
                        equipamentos_quantidades: [],
                        recursos_acessibilidade: [],
                        opcoes_uso_internet: [],
                        equipamentos_alunos_uso_internet: [],
                        equipamentos_rede_local_computadores: [],
                        instrumentos_pedagogicos: [],
                        orgaos_colegiados: [],
                        profissionais_atuam_instituicoes_qtd: [],
                        acoes_ambientais: [],
                        qtd_salas_cantinho_leitura: '',

                    }
                }

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitInstituicao(){

            document.getElementById("btn-instituicao").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                if(this.editInstituicao){

                    if(!this.dados.infra_instituicao_id){

                        this.dados.infras_instituicoes.periodo_letivo_id = this.$store.state.config.periodo.id;
                    }

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        this.uploadLogoIfNeeded(this.dados.id).then(() => {

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitInstituicao');
                            this.getInstituicoes();

                            if(this.$store.state.user.tipo <= 1){

                                this.getInstituicaoById(this.paramId);
                                window.scrollTo({ top: 0, behavior: 'smooth' });

                            }

                        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        const novoId = response.data && response.data.id ? response.data.id : null;

                        this.uploadLogoIfNeeded(novoId).then(() => {

                            window.eventBus.$emit('loading', false);
                            window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                            this.$emit('onSubmitInstituicao');
                            this.getInstituicoes();

                        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        uploadLogoIfNeeded(instituicaoId){

            if(!this.logoFile || !instituicaoId){ return Promise.resolve(); }

            const fd = new FormData();
            fd.append('logo', this.logoFile);

            return this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/instituicao-personalizacao/uploadLogo/` + instituicaoId,
                fd,
                this.$store.getters.getHeaderFileAuth
            );
        },
        onLogoErro(msg){
            if(msg){ window.eventBus.$emit('alert', {msg, type: 'warning'}); }
        },
        onLogoDelete(){

            this.logoFile = '';

            // Se está editando e havia logo salva, remove no backend
            if(this.editInstituicao && this.dados.id && this.logoUrl){

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/instituicao-personalizacao/removerLogo/` + this.dados.id, this.$store.getters.getHeaderAuth).then(() => {

                    this.logoUrl = '';
                    this.dados.logo_path = '';
                    window.eventBus.$emit('alert', {msg: 'Logo removida.', type: 'success'});

                }).catch((error) => { this.$store.commit('throwException', error); });

            }else{
                this.logoUrl = '';
            }
        },
        async localizarPeloEndereco(){
            this.localizando = true;
            try {
                const { data } = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/geocodificar`, this.dados, this.$store.getters.getHeaderAuth);
                this.dados.latitude = String(data.latitude);
                this.dados.longitude = String(data.longitude);
                window.eventBus.$emit('alert', { msg: 'Localização encontrada. Confira e ajuste no mapa, se preciso.', type: 'success' });
            } catch (e) {
                const msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : 'Não foi possível localizar o endereço.';
                window.eventBus.$emit('alert', { msg, type: 'warning' });
            }
            this.localizando = false;
        },
        confirmarMapa(p){
            this.dados.latitude = String(p.lat.toFixed(7));
            this.dados.longitude = String(p.lng.toFixed(7));
            this.dialogMapa = false;
        },
        limparEndereco(){
            this.dados.logradouro = '';
            this.dados.bairro = '';
            this.dados.cidade = '';
            this.dados.estado = '';
        },
        async buscarViaCep(){

            const cepLimpo = this.dados.cep.replace(/\D/g, '');
            if(cepLimpo.length !== 8 || this.buscandoCep) return;

            this.buscandoCep = true;

            try {
                const { data } = await this.$axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

                if(data.erro){
                    this.limparEndereco();
                    window.eventBus.$emit('alert', { msg: 'Atenção! CEP não encontrado.', type: 'warning' });
                    return;
                }

                this.dados.logradouro = data.logradouro ? this.$removerAcentos(data.logradouro.toUpperCase()) : '';
                this.dados.bairro = data.bairro ? this.$removerAcentos(data.bairro.toUpperCase()) : '';
                this.dados.cidade = data.localidade ? this.$removerAcentos(data.localidade.toUpperCase()) : '';
                this.dados.estado = data.uf ? data.uf.toUpperCase() : '';

            } catch(error) {
                this.limparEndereco();
                window.eventBus.$emit('alert', { msg: 'Atenção! Erro ao buscar CEP.', type: 'warning' });
            } finally {
                this.buscandoCep = false;
            }
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        },
        formatDataPeriodo(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.dados.periodo[field])
                return false;

            if(size && this.dados.periodo[field].length < size)
                this.dados.periodo[field] = '';

            this.dados.periodo[field] = this.dados.periodo[field].toUpperCase();

            this.dados.periodo[field] = this.$removerAcentos(this.dados.periodo[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.editInstituicao = true;

                }else{

                    this.getPeriodoSistema();
                }

            }
        },
    },
    components:{ 'input-image': InputImage, 'mapa-endereco': mapaEndereco },
    computed:{
        coordenadaAtual(){
            const lat = parseFloat(this.dados.latitude), lng = parseFloat(this.dados.longitude);
            return isNaN(lat) || isNaN(lng) ? null : { lat, lng };
        }
    }
}
</script>
